// extracted by mini-css-extract-plugin
export default {"root":"Hj8mH","withDescription":"CdHhR","titleRoot":"pl2cR"};